import { render, staticRenderFns } from "./ready.vue?vue&type=template&id=cdd1a712"
import script from "./ready.vue?vue&type=script&lang=js"
export * from "./ready.vue?vue&type=script&lang=js"
import style0 from "./ready.vue?vue&type=style&index=0&id=cdd1a712&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports